import React, { Component } from 'react';
import '../../../App.css';
import '../../../styles/app-demo.css';

class PaymentFrequency extends Component {

  render() {

    return (
      <div className="fintwist-interactive-mobile">
        <section className="mobile-app-wrapper">
          <div className="orange-header">
            <i onClick={() => this.props.handleBillPayRoute('pay amount')} className="fa fa-angle-left"></i>
            <h2>Frequency</h2>
          </div>
        <div className="mobile-app-dashboard">
          <div className="mobile-app-dashboard">
            <ul className="app-list">
              <li onClick={() => {
                  this.props.paymentFrequency('One Time')
                  this.props.handleBillPayRoute('bill pay date')
                  }}>
                <p>One Time</p>
              </li>
            </ul>
          </div>
        </div>
        </section>
      </div>
    );
  }
}

export default PaymentFrequency;
